import { useRef as e, useEffect as r } from "react";
import { IdempotenceKeyManager as o } from "../utils/idempotenceKeyManager.js";
const t = (t2) => {
  const n = e(void 0);
  r(() => "boolean" == typeof t2 ? (!t2 || false !== n.current && void 0 !== n.current || o.generateKey(), void (n.current = t2)) : (o.generateKey(), () => {
    o.clearKey();
  }), [t2]);
};
export {
  t as useIdempotenceKey
};
//# sourceMappingURL=useIdempotenceKey.js.map
